import styled from 'styled-components';

import Select from 'basics/inputs/Select';
import ToggleGroup from 'basics/inputs/ToggleGroup';

import { commonMaxWidth, flexAllCenter, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS, hexWithOpacity } from 'styles/style-constants';

export const MainBlock = styled.main`
    flex: 1 0 auto;
`;

export const ProposalsBlockWrapper = styled.div`
    padding: 8.5rem 4rem 0;
    ${commonMaxWidth};
    margin-bottom: 10rem;

    ${respondDown(Breakpoints.md)`
        padding: 5.5rem 1.6rem 0;
        background: ${COLORS.gray50};
        margin-bottom: 0;
    `}
`;

export const ProposalsBlock = styled.div`
    display: flex;
    justify-content: space-between;
    column-gap: 6rem;

    ${respondDown(Breakpoints.xl)`
        flex-direction: column;
        row-gap: 6rem;
    `}
`;

export const ProposalList = styled.div`
    flex: 3;
    display: flex;
    flex-direction: column;
`;

export const SidebarColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2.4rem;
    min-width: 0;
    align-self: flex-start;
    position: sticky;
    top: 5rem;

    ${respondDown(Breakpoints.xl)`
        position: static;
        align-self: stretch;
        width: 100%;
    `}
`;

export const TitleBlock = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 4.8rem;
    flex-direction: column;
    gap: 1rem;

    ${respondDown(Breakpoints.lg)`
        flex-direction: column;
    `}
`;

export const ProposalsTitle = styled.h3`
    font-size: 4rem;
    line-height: 6.4rem;
    font-weight: bold;
    color: ${COLORS.textPrimary};

    ${respondDown(Breakpoints.lg)`
         margin-bottom: 5.5rem;
    `}
`;

export const ToggleGroupStyled = styled(ToggleGroup)`
    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;

export const SelectStyled = styled(Select)`
    display: none;

    ${respondDown(Breakpoints.md)`
          display: flex;
    `}
`;

export const ScrollToSidebarButton = styled.div`
    display: none;
    position: fixed;
    justify-content: space-between;
    align-items: center;
    bottom: 0;
    left: 0;
    width: 100%;
    background: ${COLORS.surface};
    box-shadow: 0 -0.5rem 1rem ${hexWithOpacity(COLORS.shadow, 6)};
    border-radius: 1rem 1rem 0 0;
    padding: 2.4rem 1.6rem;
    font-size: 1.6rem;
    line-height: 2.4rem;
    font-weight: bold;
    cursor: pointer;

    ${respondDown(Breakpoints.md)`
        display: flex;
    `}
`;

export const EmptyList = styled.div`
    flex: 1;
    ${flexAllCenter};
    flex-direction: column;
`;

export const EmptyTitle = styled.span`
    font-weight: 700;
    font-size: 2rem;
    line-height: 2.8rem;
    color: ${COLORS.purple950};
    margin-bottom: 0.8rem;
`;

export const EmptyDescription = styled.div`
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.textGray};
    text-align: center;
`;

export const EmptyLink = styled.span`
    color: ${COLORS.purple500};
    text-decoration: underline;
    cursor: pointer;
`;

export const List = styled.div<{ $loading: boolean }>`
    position: relative;
    opacity: ${({ $loading }) => ($loading ? 0.5 : 1)};
    pointer-events: ${({ $loading }) => ($loading ? 'none' : 'auto')};
`;
